import { createImageApiClient } from './image-api-client.js'
import { createMockProvider } from './mock-provider.js'

export function createProvider({ config = {}, fetchImpl } = {}) {
  if (!config.baseUrl) return createMockProvider()
  const client = createImageApiClient({ fetchImpl })
  return { generate: (job, options) => client.generate(job, config, options) }
}
